import React, { useEffect, useRef, useState } from "react";
// import "./styles.css";
import Sunburst from "sunburst-chart";
import * as d3 from "d3";

let data = {
  name: "Water Data",
  children: [
    {
      minquiz: 137,
      noutquiz: 12,
      ndocs: 0,
      name: "2021",
      nvid: 33,
      moutquiz: 147,
      size: 2218,
      ninquiz: 187,
      color: "#4DC19C",
      children: [
        {
          minquiz: 15,
          noutquiz: 5,
          ndocs: 4,
          name: "Banaskantha",
          nvid: 4,
          moutquiz: 15,
          size: 2001,
          ninquiz: 12,
          color: "#F6D18A",
          children: [
            {
              minquiz: 4,
              noutquiz: 0,
              name: "water used 138 lt.",
              nvid: 1,
              moutquiz: 0,
              size: 396,
              ninquiz: 5,
              color: "#B7885E",
              value: 396
            },
            {
              minquiz: 7,
              noutquiz: 0,
              name: "water saved 27 lt.",
              nvid: 1,
              moutquiz: 0,
              size: 605,
              ninquiz: 7,
              color: "#FFCB99",
              value: 605
            },
          ]
        },
        {
            minquiz: 11,
            noutquiz: 1,
            ndocs: 0,
            name: "Mehsana",
            nvid: 2,
            moutquiz: 10,
            size: 1001,
            ninquiz: 12,
            color: "#F6D18A",
            children: [
              {
                minquiz: 4,
                noutquiz: 0,
                name: "water used 180 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 396,
                ninquiz: 5,
                color: "#B7885E",
                value: 396
              },
              {
                minquiz: 7,
                noutquiz: 0,
                name: "water saved 58 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 7,
                color: "#FFCB99",
                value: 605
              },
            ]
          },
          {
            minquiz: 11,
            noutquiz: 1,
            ndocs: 0,
            name: "Patan",
            nvid: 2,
            moutquiz: 10,
            size: 1001,
            ninquiz: 12,
            color: "#F6D18A",
            children: [
              {
                minquiz: 4,
                noutquiz: 0,
                name: "water used 170 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 396,
                ninquiz: 5,
                color: "#B7885E",
                value: 396
              },
              {
                minquiz: 7,
                noutquiz: 0,
                name: "water saved 156 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 7,
                color: "#FFCB99",
                value: 605
              },
            ]
          },
          {
            minquiz: 11,
            noutquiz: 1,
            ndocs: 0,
            name: "Sabarkantha",
            nvid: 2,
            moutquiz: 10,
            size: 1001,
            ninquiz: 12,
            color: "#F6D18A",
            children: [
              {
                minquiz: 4,
                noutquiz: 0,
                name: "water used 170 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 396,
                ninquiz: 5,
                color: "#B7885E",
                value: 396
              },
              {
                minquiz: 7,
                noutquiz: 0,
                name: "water saved 219 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 7,
                color: "#FFCB99",
                value: 605
              },
            ]
          },
      ]
    },
    {
      minquiz: 119,
      noutquiz: 10,
      ndocs: 0,
      name: "2020",
      nvid: 30,
      moutquiz: 64,
      size: 19849,
      ninquiz: 127,
      color: "#DA70BF",
      children: [
        {
          minquiz: 1,
          noutquiz: 1,
          ndocs: 0,
          name: "Banaskantha",
          nvid: 1,
          moutquiz: 0,
          size: 883,
          ninquiz: 2,
          color: "#125C77",
          children: [
            {
              minquiz: 4,
              noutquiz: 0,
              name: "water used 28.3 lt.",
              nvid: 1,
              moutquiz: 0,
              size: 396,
              ninquiz: 5,
              color: "#B7885E",
              value: 396
            },
            {
              minquiz: 7,
              noutquiz: 0,
              name: "water saved 23 lt.",
              nvid: 1,
              moutquiz: 0,
              size: 605,
              ninquiz: 7,
              color: "#FFCB99",
              value: 605
            },
          ]
        },
        {
            minquiz: 1,
            noutquiz: 1,
            ndocs: 0,
            name: "Mehsana",
            nvid: 1,
            moutquiz: 0,
            size: 883,
            ninquiz: 2,
            color: "#125C77",
            children: [
              {
                minquiz: 4,
                noutquiz: 0,
                name: "water used 177.3 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 396,
                ninquiz: 5,
                color: "#B7885E",
                value: 396
              },
              {
                minquiz: 7,
                noutquiz: 0,
                name: "water saved 53 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 7,
                color: "#FFCB99",
                value: 605
              },
            ]
          },
          {
            minquiz: 1,
            noutquiz: 1,
            ndocs: 0,
            name: "Patan",
            nvid: 1,
            moutquiz: 0,
            size: 883,
            ninquiz: 2,
            color: "#125C77",
            children: [
              {
                minquiz: 4,
                noutquiz: 0,
                name: "water used 152 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 396,
                ninquiz: 5,
                color: "#B7885E",
                value: 396
              },
              {
                minquiz: 7,
                noutquiz: 0,
                name: "water saved 172 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 7,
                color: "#FFCB99",
                value: 605
              },
            ]
          },
          {
            minquiz: 1,
            noutquiz: 1,
            ndocs: 0,
            name: "Sabarkantha",
            nvid: 1,
            moutquiz: 0,
            size: 883,
            ninquiz: 2,
            color: "#125C77",
            children: [
              {
                minquiz: 4,
                noutquiz: 0,
                name: "water used 269.4 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 396,
                ninquiz: 5,
                color: "#B7885E",
                value: 396
              },
              {
                minquiz: 7,
                noutquiz: 0,
                name: "water saved 138 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 7,
                color: "#FFCB99",
                value: 605
              },
            ]
          },
      ]
    },
    {
      minquiz: 60,
      noutquiz: 7,
      ndocs: 7,
      name: "2019",
      nvid: 70,
      moutquiz: 30,
      size: 12543,
      ninquiz: 180,
      color: "#DA70BF",
      children: [
        {
          minquiz: 0,
          noutquiz: 0,
          ndocs: 0,
          name: "Banaskantha",
          nvid: 1,
          moutquiz: 0,
          size: 605,
          ninquiz: 0,
          color: "#125C77",
          children: [
            {
              minquiz: 0,
              noutquiz: 0,
              name: " water Used 7 lt.",
              nvid: 1,
              moutquiz: 0,
              size: 605,
              ninquiz: 0,
              color: "#4DC19C",
              value: 605
            },
            {
                minquiz: 0,
                noutquiz: 0,
                name: " water Saved 7 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 0,
                color: "#4DC19C",
                value: 605
              }
          ]
        },
        {
          minquiz: 4,
          noutquiz: 1,
          ndocs: 0,
          name: "Mehsana",
          nvid: 4,
          moutquiz: 2,
          size: 2307,
          ninquiz: 9,
          color: "#776E57",
          children: [
            {
              minquiz: 0,
              noutquiz: 0,
              name: "water Used 184 lt.",
              nvid: 1,
              moutquiz: 0,
              size: 614,
              ninquiz: 1,
              color: "#12939A",
              value: 614
            },
            {
                minquiz: 0,
                noutquiz: 0,
                name: "water Saved 44 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 614,
                ninquiz: 1,
                color: "#12939A",
                value: 614
              },
          ]
        },
        {
            minquiz: 0,
            noutquiz: 0,
            ndocs: 0,
            name: "Patan",
            nvid: 1,
            moutquiz: 0,
            size: 605,
            ninquiz: 0,
            color: "#125C77",
            children: [
              {
                minquiz: 0,
                noutquiz: 0,
                name: " water Used 49 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 605,
                ninquiz: 0,
                color: "#4DC19C",
                value: 605
              },
              {
                  minquiz: 0,
                  noutquiz: 0,
                  name: " water Saved 47 lt.",
                  nvid: 1,
                  moutquiz: 0,
                  size: 605,
                  ninquiz: 0,
                  color: "#4DC19C",
                  value: 605
                }
            ]
          },
          {
            minquiz: 4,
            noutquiz: 1,
            ndocs: 0,
            name: "Sabarkantha",
            nvid: 4,
            moutquiz: 2,
            size: 2307,
            ninquiz: 9,
            color: "#776E57",
            children: [
              {
                minquiz: 0,
                noutquiz: 0,
                name: "water Used  438 lt.",
                nvid: 1,
                moutquiz: 0,
                size: 614,
                ninquiz: 1,
                color: "#12939A",
                value: 614
              },
              {
                  minquiz: 0,
                  noutquiz: 0,
                  name: "water Saved 11 lt.",
                  nvid: 1,
                  moutquiz: 0,
                  size: 614,
                  ninquiz: 1,
                  color: "#12939A",
                  value: 614
                },
            ]
          },
      ]
    },
  ]
};

let chart = Sunburst();

export default function Pichart() {
  const [chartState, setChartState] = useState();

  const color = d3.scaleOrdinal(d3.schemePaired);
  useEffect(() => {
    chart
      .data(data)
      .width(600)
      .height(600)
      .sort((a, b) => b.value - a.value)
      .color((d) => color(d.name))
      .excludeRoot(true)(document.getElementById("chart-sunburst"));
  }, [data]);

  return (
    <div id="chart-sunburst-graph" className="treeGraph">
      <div id="chart-sunburst"></div>
    </div>
  );
}
